import React from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { renderApplicantOptionMin } from '../../../utils/formatters';
import { PROCEDURE_TYPE } from '../../../configs';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import CustomSelectInputWithHelper from '../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import { loadApplicantList } from '../actions';
import { getExistFields, setValueByPath } from '../../../utils/utils';
import renderMessage from '../../../components/fields/renderMessage';
import RepresentativeDTO from '../../../dto/RepresentativeDTO';

export default function AutoAcceptApplicant(props) {
  const {
    getValues, control, prefix = '', loadApplication = () => {}, procedure, setDefault = () => {}, disabled,
  } = props;
  const dto = new RepresentativeDTO();
  const attributes = dto.getAttributesByName();
  const dispatch = useDispatch();

  const optionFormatter = item => ({
    value: item.id, name: item.full_name, applicant: item,
  });

  const onSelectApplicant = item => {
    const { applicant } = item;
    if (applicant === undefined) {
      return;
    }
    const isPartial = [PROCEDURE_TYPE.PROCEDURE_1227_3, PROCEDURE_TYPE.PROCEDURE_1227_5, PROCEDURE_TYPE.PROCEDURE_1227_7, PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure);
    const data = {
      ...getValues(),
      applicant: {
        ...getExistFields(isPartial ? getValues('applicant') : {}),
        ...applicant,
      },
      decision: applicant.decision || '',
    };
    // setValueByPath(data, 'applicant.inn', data.applicant.inn);
    // setValueByPath(data, 'applicant.ogrn', data.applicant.ogrn);

    if ([PROCEDURE_TYPE.PROCEDURE_1227_2, PROCEDURE_TYPE.PROCEDURE_1227_4, PROCEDURE_TYPE.PROCEDURE_1227_5, PROCEDURE_TYPE.PROCEDURE_1227_3].includes(procedure)) {
      if (procedure === PROCEDURE_TYPE.PROCEDURE_1227_5) {
        setValueByPath(data, `${prefix}carriage_contract_number`, applicant.carriage_contract_number || '');
        setValueByPath(data, `${prefix}carriage_contract_effective_date`, applicant.carriage_contract_effective_date || '');
        setValueByPath(data, `${prefix}carriage_contract_expiration_date`, applicant.carriage_contract_expiration_date || '');
        setValueByPath(data, `${prefix}driver_license_series`, applicant.driver_license_series || '');
        setValueByPath(data, `${prefix}driver_license_number`, applicant.driver_license_number || '');
        setValueByPath(data, `${prefix}driver_license_issue_date`, applicant.driver_license_issue_date || '');
        setValueByPath(data, `${prefix}driver_license_expiration_date`, applicant.driver_license_expiration_date || '');
      }

      delete data?.applicant.vehicles;
      delete data?.applicant.order_services;
    }

    setValueByPath(data, `${prefix}effective_date`, applicant.effective_date || '');
    setValueByPath(data, `${prefix}expiration_date`, applicant.expiration_date || '');

    if (procedure === PROCEDURE_TYPE.PROCEDURE_1228_3) {
      setValueByPath(data, `${prefix}web_site`, applicant.web_site || '');
      setValueByPath(data, `${prefix}software_names`, applicant.software_names || '');
      setValueByPath(data, `${prefix}database_address`, applicant.database_address || '');
      setValueByPath(data, `${prefix}server_address`, applicant.server_address || '');
      setValueByPath(data, `${prefix}order_receiving_methods`, applicant.order_receiving_methods || '');
    }

    setValueByPath(data, `${prefix}`, getExistFields(getValues(prefix)) || '');
    setValueByPath(data, 'applicant.isMatch', false);
    setDefault(data);
  };

  const customToggleContent = (props, value, options, anchorElement) => {
    const {
      label,
      isRequired,
      fieldState = {
        error: '',
      },
    } = props;
    const { error } = fieldState;
    const isError = Boolean(error);
    const item = options.find(option => option.value === value);
    return (
      <div className="form-control-wrapper material auto-accept-applicant-input" ref={anchorElement}>
        <div className={classNames('input-block', { 'is-invalid': isError })} title={renderMessage(label)}>
          {renderApplicantOptionMin(item)}
          <div htmlFor={props.id} className="form-input-label">
            {isRequired ? <span className="form-label-mark-required">*</span> : null}
            {renderMessage(label)}
          </div>
          <span className="input-after-block">
            <div className="select-arrow-wrapper">
              <Icons customIcon className="select-arrow" width={12} height={8} icon="arrow-down" />
            </div>
          </span>
        </div>
        {isError ? <div className="invalid-feedback">{renderMessage(error)}</div> : null}
      </div>

    );
  };
  // const status = getValues(`${prefix}applicant_status`);
  const status = 0;
  return (
    <FieldDTO
      control={control}
      dtoObject={attributes.applicant_id}
      usePortal
      withLabel
      variant="material"
      disabled={disabled}
      component={CustomSelectInputWithHelper}
      portalClassName="executor-selector"
      className="mt-3"
      loadAction={loadApplicantList}
      customRenderOptions={renderApplicantOptionMin}
      optionFormatter={optionFormatter}
      customToggleContent={customToggleContent}
      filterName="search"
      onSelect={onSelectApplicant}
    />
  );
}
